import { getAutoPaymentStatus } from 'portal-modules/payments/api/api'
import { call, put, takeLatest } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
export const REQUEST_AUTO_PAYMENT_STATUS = 'rp/autopayment/AUTO_PAYMENT_STATUS'
export const RECEIVE_AUTO_PAYMENT_STATUS = 'rp/autopayment/RECEIVE_AUTO_PAYMENT_STATUS'
export const RESET_AUTO_PAYMENT_STATUS = 'rp/autopayment/RESET_AUTO_PAYMENT_STATUS'

// action creators
export const requestAutoPaymentStatus = (payload, callback = () => {}) => ({
  type: REQUEST_AUTO_PAYMENT_STATUS,
  payload,
  callback,
})

export const receiveAutoPaymentStatus = payload => ({
  type: RECEIVE_AUTO_PAYMENT_STATUS,
  payload,
})

export const resetAutoPaymentStatus = () => ({ type: RESET_AUTO_PAYMENT_STATUS })

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_AUTO_PAYMENT_STATUS:
      return { ...state, ...payload }
    case RESET_AUTO_PAYMENT_STATUS:
      return {}
    default:
      return state
  }
}

// sagas
export function* fetchAutoPaymentStatus({ payload, callback }) {
  const responseData = yield call(getAutoPaymentStatus, payload);
  yield put(receiveAutoPaymentStatus(responseData))
  if (typeof callback === 'function') {
    yield callback()
  }
}

export function* watchAutoPaymentStatus() {
  yield takeLatest(
    REQUEST_AUTO_PAYMENT_STATUS,
    createRequestSaga(fetchAutoPaymentStatus, {
      key: 'autopayments',
      message: __('Getting Auto Payment Status'),
    }),
  )
}

export const sagas = [watchAutoPaymentStatus]
